type PrimitiveSupportedGateTypes = boolean | number | string;
export type SupportedGateTypes =
  | Array<PrimitiveSupportedGateTypes>
  | PrimitiveSupportedGateTypes
  | {
      [key: string]: PrimitiveSupportedGateTypes;
    };

/**
 * Feature gates / experiments in Statsig have to be defined here as well.
 * The `owner` field should be your Trello username.
 */
export const featureGates = {
  billplat_board_switcher_panel: {
    createdOn: '2025-06-13',
    owner: 'pperry',
  },
  billplat_ccp_create_workspace: {
    createdOn: '2024-07-09',
    owner: 'jborczuk',
  },
  billplat_edm_new_react_controller_view: {
    createdOn: '2025-07-16',
    owner: 'kchen9',
  },
  billplat_edm_public_boards_tab: {
    createdOn: '2025-05-02',
    owner: 'kchen9',
  },
  billplat_edm_workspace_board_settings: {
    createdOn: '2025-05-14',
    owner: 'tsiddiqui',
  },
  billplat_edm_workspaces_page: {
    createdOn: '2025-05-05',
    owner: 'pperry',
  },
  billplat_inbox_quickcapture_upsell: {
    createdOn: '2025-03-03',
    owner: 'pperry',
  },
  billplat_island_nav_labels: {
    createdOn: '2025-06-06',
    owner: 'pperry',
  },
  billplat_m2_workspace_pages: {
    createdOn: '2024-11-27',
    owner: 'pperry',
  },
  billplat_modernize_enterprise_sso_tab: {
    createdOn: '2025-06-25',
    owner: 'tsiddiqui',
  },
  billplat_modernize_member_home: {
    createdOn: '2025-05-29',
    owner: 'pperry',
  },
  billplat_soft_deprovisioning: {
    createdOn: '2025-07-08',
    owner: 'jborczuk',
  },
  billplat_workspace_settings_navigation: {
    createdOn: '2025-03-17',
    owner: 'kchen9',
  },
  ecosystem_listing_updates_dev: {
    createdOn: '2025-06-04',
    owner: 'ktran2',
  },
  ecosystem_listing_updates_directory: {
    createdOn: '2025-06-20',
    owner: 'ktran2',
  },
  ecosystem_power_up_views: {
    createdOn: '2024-10-02',
    owner: 'jlo',
  },
  electric_multi_account: {
    createdOn: '2025-07-22',
    owner: 'jday2',
  },
  elements_unset_duplicate_dsc_cookie: {
    createdOn: '2024-10-09',
    owner: 'rwang3',
  },
  enterprise_card_back_add_to_inbox: {
    createdOn: '2025-05-20',
    owner: 'dbernal',
  },
  enterprise_email_verification_refresher: {
    createdOn: '2025-01-24',
    owner: 'dbernal',
  },
  enterprise_link_to_atlassian_org_v2_web: {
    createdOn: '2024-09-13',
    owner: 'mkalil',
  },
  ghost_crossflow_live_checks: {
    createdOn: '2025-05-12',
    owner: 'dvenkatachalam',
  },
  ghost_mirror_card_back_subscription: {
    createdOn: '2025-01-14',
    owner: 'jsaussy',
  },
  ghost_mirror_card_popover_tabs: {
    createdOn: '2025-05-17',
    owner: 'jsaussy',
  },
  ghost_mirror_cards_board_filter: {
    createdOn: '2025-05-02',
    owner: 'mshih',
  },
  ghost_mirror_popover_experiment_gate: {
    createdOn: '2025-05-06',
    owner: 'jsaussy',
  },
  ghost_one_subscription_per_mirror: {
    createdOn: '2025-02-25',
    owner: 'jsaussy',
  },
  ghost_patch_shared_state_selector: {
    createdOn: '2025-03-26',
    owner: 'achung',
  },
  ghost_poll_user_traits: {
    createdOn: '2025-06-05',
    owner: 'achung',
  },
  ghost_simulate_new_user_dev: {
    createdOn: '2025-05-21',
    owner: 'dvenkatachalam',
  },
  ghost_use_mirror_card_subscriptions: {
    createdOn: '2024-12-16',
    owner: 'jsaussy',
  },
  ghost_use_react_focus_lock: {
    createdOn: '2025-02-26',
    owner: 'mshih',
  },
  ghost_use_react_focus_lock_pups: {
    createdOn: '2025-04-08',
    owner: 'slondon',
  },
  ghost_use_server_add_starter_guide: {
    createdOn: '2025-04-10',
    owner: 'achung',
  },
  ghost_xf_use_ga_modal_trait: {
    createdOn: '2025-05-28',
    owner: 'dvenkatachalam',
  },
  goo_ai_eligibility_quickcapture_ga_check: {
    createdOn: '2025-03-14',
    defaultValue: false,
    owner: 'fkrawczyk',
  },
  goo_allow_disabling_keyboard_shortcuts: {
    createdOn: '2025-05-20',
    defaultValue: false,
    owner: 'evgeniyagorobets1',
  },
  goo_cache_sync_in_separate_type_policies: {
    createdOn: '2025-05-06',
    owner: 'evgeniyagorobets1',
  },
  goo_card_back_cache_syncing: {
    createdOn: '2025-06-09',
    owner: 'evgeniyagorobets1',
  },
  goo_client_workspace_subscriptions: {
    createdOn: '2024-04-23',
    owner: 'stuo',
  },
  goo_graphql_connectivity_flags: {
    createdOn: '2024-10-17',
    owner: 'ccurtis',
  },
  goo_horsefly_dev_portal: {
    createdOn: '2025-05-29',
    owner: 'cgarrison',
  },
  goo_send_memory_attributes: {
    createdOn: '2025-05-30',
    owner: 'jcostello2',
  },
  goo_send_ws_ping: {
    createdOn: '2025-07-11',
    owner: 'ccurtis',
  },
  goo_slower_client_reconnects: {
    createdOn: '2024-10-21',
    owner: 'ccurtis',
  },
  goo_subscribe_split_card_update: {
    createdOn: '2025-03-13',
    owner: 'jcostello2',
  },
  gql_client_subscriptions: {
    createdOn: '2024-10-28',
    owner: 'egorobets',
  },
  gqldata_email_attachment_preview: {
    createdOn: '2024-09-12',
    owner: 'cgarrison',
  },
  gqldata_inbox_email_ai: {
    createdOn: '2024-10-18',
    owner: 'cgarrison',
  },
  legacy_url_error_page: {
    createdOn: '2024-09-10',
    owner: 'mkalil',
  },
  phx_ai_settings: {
    createdOn: '2025-07-03',
    owner: 'cma2',
  },
  phx_board_switcher_spotlight_pulse: {
    createdOn: '2025-04-15',
    owner: 'hburinda',
  },
  phx_bulk_actions: {
    createdOn: '2025-06-26',
    owner: 'ajaiman',
  },
  phx_card_back_feedback: {
    createdOn: '2025-02-14',
    owner: 'mellis',
  },
  phx_card_back_onboarding: {
    createdOn: '2025-04-07',
    owner: 'mellis',
  },
  phx_card_back_redesign: {
    createdOn: '2025-01-06',
    owner: 'mellis',
  },
  phx_inbox_auto_archive_m1: {
    createdOn: '2025-04-24',
    owner: 'dstraus',
  },
  phx_inbox_auto_archive_m2: {
    createdOn: '2025-05-13',
    owner: 'dstraus',
  },
  phx_inbox_auto_archive_override: {
    createdOn: '2025-04-28',
    owner: 'dstraus',
  },
  phx_modernize_board_collections_ux: {
    createdOn: '2025-06-24',
    owner: 'agupta45',
  },
  phx_preload_trello_editor: {
    createdOn: '2025-06-11',
    owner: 'dstraus',
  },
  phx_pup_description_editor: {
    createdOn: '2025-05-21',
    owner: 'mellis',
  },
  phx_pup_directory_modernization: {
    createdOn: '2025-04-14',
    owner: 'hburinda',
  },
  phx_pup_header_settings: {
    createdOn: '2025-07-03',
    owner: 'cma2',
  },
  phx_rovo_card_back: {
    createdOn: '2025-05-12',
    owner: 'ajaiman',
  },
  phx_rovo_island: {
    createdOn: '2025-05-06',
    owner: 'ajaiman',
  },
  phx_shape_theme: {
    createdOn: '2025-06-17',
    owner: 'mellis',
  },
  phx_smart_schedule_m1: {
    createdOn: '2025-06-18',
    owner: 'ajaiman',
  },
  phx_trello_card_attachment_modernization: {
    createdOn: '2025-07-09',
    owner: 'mramosmartins',
  },
  phx_trello_card_improvements: {
    createdOn: '2025-06-03',
    owner: 'mramosmartins',
  },
  phx_typography_refresh: {
    createdOn: '2025-04-10',
    owner: 'mellis',
  },
  phx_user_traits_optimization: {
    createdOn: '2025-05-28',
    owner: 'dstraus',
  },
  phx_zen_mode: {
    createdOn: '2025-02-14',
    owner: 'ajaiman',
  },
  'platform-component-visual-refresh': {
    createdOn: '2025-04-11',
    owner: 'mellis',
  },
  tplat_native_graphql_migration_milestone_2: {
    createdOn: '2024-09-11',
    owner: 'koduche',
  },
  tplat_report_cls_web_vitals: {
    createdOn: '2025-06-17',
    owner: 'dminshew',
  },
  tplat_report_inp_web_vitals: {
    createdOn: '2025-06-17',
    owner: 'dminshew',
  },
  'trello-member-cards-query': {
    createdOn: '2025-04-16',
    owner: 'greznicov',
  },
  'trello-server-e2b-ai': {
    createdOn: '2024-05-14',
    owner: 'brianzawisza1',
  },
  'trello-web-seat-automation-member-blocklist': {
    createdOn: '2024-08-08',
    owner: 'alitskevitch',
  },
  trello_ads_icons: {
    createdOn: '2025-04-15',
    owner: 'wloo2',
  },
  trello_beta_ga: {
    createdOn: '2025-04-14',
    owner: 'bessary',
  },
  trello_beta_ga_announcement: {
    createdOn: '2025-04-14',
    owner: 'bessary',
  },
  trello_block_smart_list_spotlight: {
    createdOn: '2025-03-13',
    owner: 'bessary',
  },
  trello_electric_use_login_hint: {
    createdOn: '2025-07-15',
    owner: 'afecenko',
  },
  trello_enterprise_inbox_archived_cards_search: {
    createdOn: '2025-03-12',
    owner: 'jlei',
  },
  trello_enterprise_pp_disable_planner_panel: {
    createdOn: '2025-06-24',
    owner: 'jlei',
  },
  trello_enterprise_shadowit_member_in_workspace: {
    createdOn: '2025-06-16',
    owner: 'jlei',
  },
  trello_feature_gate_client_init_with_provider: {
    createdOn: '2025-02-20',
    owner: 'achung',
  },
  trello_goo_custom_ai_prompts: {
    createdOn: '2025-05-19',
    owner: 'fkrawczyk',
  },
  trello_hover_inbetween_cards: {
    createdOn: '2024-09-27',
    owner: 'greznicov',
  },
  trello_native_graphql_migration_milestone_1: {
    createdOn: '2024-07-12',
    owner: 'koduche',
  },
  'trello_non-ppm_single_player': {
    createdOn: '2024-01-22',
    owner: 'achung',
  },
  trello_outlook_announcement: {
    createdOn: '2025-06-18',
    owner: 'bessary',
  },
  trello_paid_workspaces: {
    createdOn: '2024-03-01',
    owner: 'wloo2',
  },
  trello_personal_productivity_release: {
    createdOn: '2024-11-13',
    owner: 'sronderos',
  },
  trello_pp_beta_box: {
    createdOn: '2024-12-19',
    owner: 'greznicov',
  },
  trello_reverse_trials: {
    createdOn: '2024-10-07',
    owner: 'greznicov',
  },
  trello_simplify_inbox_card_back: {
    createdOn: '2025-05-15',
    owner: 'greznicov',
  },
  trello_web_inbox_bulk_actions: {
    createdOn: '2025-05-27',
    owner: 'abenouna',
  },
  trello_web_pinned_cards: {
    createdOn: '2024-06-07',
    owner: 'jlei',
  },
  trello_web_positioning_midpoint: {
    createdOn: '2025-05-02',
    owner: 'nholets',
  },
  trello_xf_discovery_ads_control: {
    createdOn: '2024-08-02',
    owner: 'achung',
  },
  trello_xf_experiment_analytics_toggle: {
    createdOn: '2024-03-11',
    owner: 'achung',
  },
  trello_xf_exposure_event_rate_limiting: {
    createdOn: '2025-04-09',
    owner: 'gbolloch',
  },
  trello_xf_invite_experience_2: {
    createdOn: '2024-05-14',
    owner: 'mleaf',
  },
  trello_xf_invite_skip_create_confirmation: {
    createdOn: '2025-05-19',
    owner: 'ldahill',
  },
  trello_xf_one_liner_header_experience: {
    createdOn: '2024-05-10',
    owner: 'mshih',
  },
  trello_xf_post_office_board_screen_placement: {
    createdOn: '2024-10-24',
    owner: 'gbolloch',
  },
  trello_xf_use_card_drag_external: {
    createdOn: '2024-05-08',
    owner: 'jsaussy',
  },
  trello_xf_use_view_for_calendar_powerup: {
    createdOn: '2024-04-23',
    owner: 'jsaussy',
  },
  xf_disable_cache_syncing_in_mirror_card_connection: {
    createdOn: '2025-06-20',
    owner: 'jsaussy',
  },
  xf_inbox_spike: {
    createdOn: '2024-06-03',
    owner: 'afecenko',
  },
  xf_mirror_cards: {
    createdOn: '2024-07-24',
    owner: 'slondon',
  },
  xf_planner_auto_updating_date: {
    createdOn: '2025-04-17',
    owner: 'tvanh',
  },
  xf_planner_card_actions: {
    createdOn: '2025-06-23',
    owner: 'kbarrett',
  },
  xf_planner_card_back_subscriptions: {
    createdOn: '2025-06-17',
    owner: 'jnierendorf',
  },
  xf_planner_card_quick_actions_scheduler: {
    createdOn: '2025-06-11',
    owner: 'handrulis',
  },
  xf_planner_event_preloading: {
    createdOn: '2025-05-20',
    owner: 'tvanh',
  },
  xf_planner_event_preview_temporary: {
    createdOn: '2025-06-24',
    owner: 'jday2',
  },
  xf_planner_outlook: {
    createdOn: '20205-05-14',
    owner: 'acrawford',
  },
  xf_planner_simpler_adjust_view: {
    createdOn: '2025-07-14',
    owner: 'tvanh',
  },
  xf_planner_single_card_event: {
    createdOn: '2025-04-07',
    owner: 'handrulis',
  },
  xf_plugin_modernization_popover_views: {
    createdOn: '2025-05-28',
    owner: 'lren',
  },
  xf_quickcard_use_ak_portal: {
    createdOn: '2025-07-09',
    owner: 'kbarrett',
  },
  xf_statsig_feature_gates_refresher: {
    createdOn: '2024-10-10',
    owner: 'achung',
  },
} as const;

export const featureExperiments = {
  ghost_nuo_drag_and_drop_optimization: {
    createdOn: '2025-07-17',
    owner: 'wloo2',
    parameters: {
      cohort: ['control', 'experiment'],
    },
    primaryIdentifier: 'atlassianAccountId',
  },
  ghost_planner_discovery: {
    createdOn: '2025-06-02',
    owner: 'devenkatachalam',
    parameters: {
      cohort: ['control', 'experiment'],
    },
    primaryIdentifier: 'atlassianAccountId',
  },
  ghost_qc_discovery: {
    createdOn: '2025-06-02',
    owner: 'achung',
    parameters: {
      qcDiscoveryUx: ['launchScreen', 'infoPanel'],
    },
    primaryIdentifier: 'atlassianAccountId',
  },
  'new_user_onboarding_flow_and_in-product_discovery': {
    createdOn: '2025-01-31',
    owner: 'achung',
    parameters: {
      campaign: ['moonshot', 'newUserSplitScreenOnboarding'],
    },
    primaryIdentifier: 'atlassianAccountId',
  },
  xf_boards_home_sidebar_placement: {
    createdOn: '2025-01-13',
    owner: 'gbolloch',
    parameters: {
      cohort: ['control', 'experiment'],
    },
    primaryIdentifier: 'atlassianAccountId',
  },
  xf_de_facto_bandits_grs_trello_feature_integration: {
    createdOn: '2025-02-14',
    owner: 'achung',
    parameters: {
      cohort: ['experiment', 'control'],
    },
    primaryIdentifier: 'atlassianAccountId',
  },
} as const;

// When adding a new layer, change the object type as shown below
// export const featureLayers = {} as const;
export const featureLayers: Record<string, { parameters: object }> = {};

export type FeatureGateKeys = keyof typeof featureGates;
export type FeatureExperimentKeys = keyof typeof featureExperiments;
export type FeatureLayersKeys = keyof typeof featureLayers;
export type FeatureExperimentParameters<
  TExperimentKey extends FeatureExperimentKeys,
> = keyof (typeof featureExperiments)[TExperimentKey]['parameters'];
export type FeatureExperimentPrimaryIdentifiers =
  | 'analyticsAnonymousId'
  | 'atlassianAccountId'
  | 'trelloUserId'
  | 'trelloWorkspaceId';
export type FeatureLayerParameters<TLayerKey extends FeatureLayersKeys> =
  keyof (typeof featureLayers)[TLayerKey]['parameters'];

export type RegisteredFeatureKey = FeatureExperimentKeys | FeatureGateKeys;

/**
 * Used to narrow down to the experiment variations types, given the experiment key and parameter key
 * e.g. type Variations = ExperimentVariations<'trello_experiment_key', 'cohort'>
 */
export type ExperimentVariations<
  TExperimentKey extends FeatureExperimentKeys,
  TExperimentParam extends FeatureExperimentParameters<TExperimentKey>,
> =
  // Explicit any type is used where we don't actually care about the type. It is used just so we can then
  // index on the variation tuples using [number].
  | 'not-enrolled'
  | ((typeof featureExperiments)[TExperimentKey]['parameters'] extends Record<
      TExperimentParam,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      any
    >
      ? (typeof featureExperiments)[TExperimentKey]['parameters'][TExperimentParam][number]
      : never);

/**
 * Used to narrow down to the experiment variations types, given the layer key and parameter key
 * e.g. type Variations = ExperimentVariations<'trello_layer_key', 'cohort'>
 */
export type LayerVariations<
  TLayerKey extends FeatureLayersKeys,
  TLayerParam extends FeatureLayerParameters<TLayerKey>,
> =
  // Explicit any type is used where we don't actually care about the type. It is used just so we can then
  // index on the variation tuples using [number].
  | 'not-enrolled'
  | ((typeof featureLayers)[TLayerKey]['parameters'] extends Record<
      TLayerParam,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      any
    >
      ? (typeof featureLayers)[TLayerKey]['parameters'][TLayerParam][number]
      : never);
